import { useState } from "react";
import { hotTopics } from "../../../mocks/clueSite";

export default function TopicWall() {
  const [showAll, setShowAll] = useState(false);
  const list = showAll ? hotTopics : hotTopics.slice(0, 10);
  return (
    <section id="topics" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-6 items-center rounded bg-accent-500 px-2 text-xs font-semibold text-foreground-950">
                热
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">话题墙</h2>
            </div>
            <p className="mt-2 text-sm text-foreground-600">高频被扒的标签与正在发酵的线索话题，点标签可直达相关线报。</p>
          </div>
          <button
            onClick={() => setShowAll((v) => !v)}
            className="inline-flex items-center gap-1 rounded-full border border-foreground-200 px-3.5 py-1.5 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
          >
            {showAll ? "收起" : "展开全部"}
            <i className={showAll ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
          </button>
        </div>

        <div className="mt-7 flex flex-wrap gap-2.5">
          {list.map((t, i) => {
            const big = i < 4;
            return (
              <a
                key={t.label}
                href="#feed"
                className={`tag-pill lift inline-flex items-center gap-2 rounded-full whitespace-nowrap ${
                  big
                    ? "bg-foreground-950 text-background-50 hover:bg-primary-600"
                    : "bg-background-50 border border-background-200 text-foreground-700 hover:border-accent-400 hover:text-accent-700"
                } px-4 py-2 text-sm md:text-[15px]`}
              >
                <i className={`${big ? "ri-fire-fill text-accent-400" : "ri-hashtag text-primary-500"} text-base`} />
                {t.label}
                <span className={`font-number text-xs font-bold ${big ? "text-accent-300" : "text-foreground-500"}`}>
                  {t.heat}
                </span>
              </a>
            );
          })}
        </div>

        <div className="mt-8 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-center text-xs text-foreground-500">
          想追的选题没人发？<span className="text-primary-700 font-medium">发个线索占位</span>，编辑组会评估是否开启专项征集。
        </div>
      </div>
    </section>
  );
}